module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h2', [_vm._v("Vehicle Availability Detail")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "error"
  }, [_vm._v("Note:- Please Select " + _vm._s(_vm.vCount) + " Vehicle for this TPT assignment..!")])]), _vm._v(" "), (_vm.vehicleArray.length > 0) ? _c('p', _vm._l((_vm.vehicleArray), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('md-chip', {
      attrs: {
        "md-deletable": ""
      },
      on: {
        "delete": function($event) {
          _vm.delete1(index)
        }
      }
    }, [_vm._v(_vm._s(item))])], 1)
  })) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), (_vm.showMailDetails.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "truckDetail2222"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Add")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.showMailDetails), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regdNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.location_description))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": parseInt(_vm.vCount) == _vm.vehicleArray.length ? true : false
      },
      on: {
        "click": function($event) {
          _vm.addVehicle(item.regdNo)
        }
      }
    }, [_c('md-icon', [_vm._v("add")])], 1)], 1)])
  }))])]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa320f3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/vehicleDetailLocation.vue
// module id = 2917
// module chunks = 0